// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/global.css");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../dialog/dialog.css");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".panel_8c0 { /* TODO: Invert dependency using :externals CSS Modules selector */\n\n  position: relative;\n\n  margin-top: 16px;\n  padding: 12px 0 16px 16px;\n\n  border-top: 1px solid rgba(0, 42, 76, 0.1);\n\n  border-top: 1px solid var(--ring-popup-border-color)\n}\n\n.panel_8c0:empty {\n    display: none;\n  }\n\n.panel_8c0 button {\n    margin-right: 8px;\n  }\n", ""]);
// Exports
exports.locals = {
	"unit": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unit"] + "",
	"panel": "panel_8c0 " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["panel"] + ""
};
module.exports = exports;
